import { createTypedState, IModuleState } from '@aclass/core/storage/states/module.state';
import { List, Map } from 'immutable';

export interface IExtraPricesModuleState extends IModuleState {

    /**
     * Identifies that all data for search page is loaded
     */
    searchPageInitialized: boolean | null;

    /**
     * Collapsible form status
     */
    searchPageCollapsed: boolean | null;

    /**
     * Trigger to identify that search is running
     */
    searchPageLock: boolean | null;

    /**
     * Search form data
     */
    searchPageForm: any;

    /**
     * A list of product ids from ORM
     */
    searchPageResults: List<number>;

    searchPageDestinations: List<any>;
    searchPageCombinations: List<any>;

    searchPageFilterDestinations: List<any>;

    searchPageFilterTours: List<any>;
    searchPageFilterCombinations: List<any>;

    searchPageTours: List<any>;

    createPageDestinations: List<any>;

    createPageCombinations: List<any>;

    createPageTours: any;

    editPageDestinations: List<any>;
    editPageTours: List<any>;
    editPageCombinations: List<any>;

    /**
     * The pagination data
     */
    searchPagePagination: Map<string, number> | null;

    /**
     * The order data
     */
    searchPageOrder: Map<string, string> | null;

    /**
     * Create form data
     */
    createPageForm: any;

    /**
     * The the save button lock
     */
    createPageSaveLock: boolean | null;

    /**
     * The tours and destination loading lock
     */
    createPageSearchLock: boolean | null;

    /**
     * A list of tours ids from ORM
     */
    createPageToursIds: List<string>;

    /**
     * A list of destinations ids from ORM
     */
    createPageDestinationsIds: List<string>;

    /**
     * A list of combinations ids from ORM
     */
    createPageCombinationsIds: List<string>;

    createPageDestinationsMappings: any;

    createPageCombinationsMappings: any;

    /**
     * The id of product
     */
    editPageRecordId: number | null;


    editPageFormValue: any;

    createPageInitialized: boolean | null;
    createPageFormValue: any;

    /**
     * Modal trigger
     */
    showRemoveModal: boolean | null;

    /**
     * Locks delete button
     */
    removeModalLock: boolean | null;

    /**
     * The the save button lock
     */
    editPageSaveLock: boolean | null;

    /**
     * The tours and destination loading lock
     */
    editPageSearchLock: boolean | null;

    /**
     * A list of tours ids from ORM
     */
    editPageToursIds: List<string>;

    /**
     * A list of destinations ids from ORM
     */
    editPageDestinationsIds: List<string>;

    /**
     * A list of combinations ids from ORM
     */
    editPageCombinationsIds: List<string>;

    editPageDestinationsMappings: any;

    editPageCombinationsMappings: any;

    /**
     * Edit form data
     */
    editPageForm: any;
}

export const INITIAL_EXTRA_PRICES_STATE = createTypedState<IExtraPricesModuleState>({
    searchPageInitialized: null,
    searchPageCollapsed: null,
    searchPageLock: null,
    searchPageForm: { },
    searchPageResults: [],
    searchPageDestinations: [],
    searchPageCombinations: [],
    searchPageTours: [],
    searchPageFilterDestinations: [],
    searchPageFilterTours: [],
    searchPageFilterCombinations: [],
    createPageCombinations: [],
    createPageDestinations: [],
    createPageTours: [],
    editPageDestinations: [],
    editPageTours: [],
    editPageCombinations: [],
    searchPagePagination: null,
    searchPageOrder: null,
    createPageInitialized: null,
    createPageForm: { },
    createPageSaveLock: null,
    createPageSearchLock: null,
    createPageToursIds: [],
    createPageDestinationsIds: [],
    createPageCombinationsIds: [],
    createPageDestinationsMappings: { },
    createPageCombinationsMappings: { },
    editPageRecordId: null,
    editPageFormValue: { },
    createPageFormValue: { },
    showRemoveModal: null,
    removeModalLock: null,
    editPageSaveLock: null,
    editPageSearchLock: null,
    editPageToursIds: [],
    editPageDestinationsIds: [],
    editPageCombinationsIds: [],
    editPageDestinationsMappings: { },
    editPageCombinationsMappings: { },
    editPageForm: { },
});
